import React, {useEffect, useState} from "react"
import axios, { Axios } from 'axios'

export default function ContactPage() {

    const [username, setUsername] = useState('')
    const [email, setEmail] = useState('')
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')

    const [usernameError, setUsernameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [subjectError, setSubjectError] = useState('');
    const [messageError, setMessageError] = useState('');


       const validateUsername = (value) => {
        const regex = /^$|^[a-zA-Zа-яА-ЯёЁ0-9-_]+$/;
        if (value.includes(' ')) {
            setUsernameError('Username cannot contain spaces');
            return false;
        } else if (!regex.test(value)) {
            setUsernameError('Username can only contain cyrillic or latin letters, numbers, hyphens, and underscores');
            return false;
        } else if (value.length > 30) {
            setUsernameError('Maximum 30 characters allowed for username');
            return false;
        } else {
            setUsernameError('');
            return true;
        }
    };

    const validateEmail = (value) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!regex.test(value)) {
            setEmailError('Invalid email format');
            return false;
        } else {
            setEmailError('');
            return true;
        }
    };

      const validateSubject = (value) => {

        if (value.length > 50) {
            setSubjectError('Maximum 50 characters allowed for subject');
            return false;
        } else {
            setSubjectError('');
            return true;
        }
    };

     const validateMessage = (value) => {

         if (value.length > 700) {
            setMessageError('Maximum 700 characters allowed for message');
            return false;
        } else {
            setMessageError('');
            return true;
        }
    };

    
    const [alertState, setAlertState] = useState(0)
    const [alertStateWrong, setAlertStateWrong] = useState(0)

    const closeAlert =() => {
        setAlertState(0)
        setAlertStateWrong(0)
    }


      const sendMessageToPost =() => {
        axios.post(`${process.env.REACT_APP_BACKEND}/sendMessageToPost`, {
            username: username, 
            email: email,
            subject: subject,
            message: message
        }).then((response) => {
            setAlertState(1);
        }).catch((err) => {
            console.log(err.message)
            setAlertStateWrong(1);
        })
        
    }

    return (
        <div className="contactPage">
        <div className="contactPageDiv" id="contactPageDivId">
        <div className="contactInfoDiv">
          <form className="emailFormCard">
            <h2 className="contactText">Contact form</h2>
            <div className="registerFormColumnCard">
            <label className="nicknameEmail" id="nicknameEmail">Your Name</label>

            <input type="text" className="buttonFormEmailClass" 
                onChange={(e) => {
                    setUsername(e.target.value)
                    validateUsername(e.target.value);
                }}/>
            {usernameError && <span className="error" id="errorSendEmail">{usernameError}</span>}
            </div>

            <div className="registerFormColumnCard">
            <label className="emailEmail" id="emailEmail">Your Email</label>

            <input type="text" className="buttonFormEmailClass"
                onChange={(e) => {
                setEmail(e.target.value)
                validateEmail(e.target.value);
            }}/>
            {emailError && <span className="error" id="errorSendEmail">{emailError}</span>}
            </div>
            
            <div className="registerFormColumnCard">
            <label className="subjectEmail" id="subjectEmail">Subject</label>

            <input id="buttonFormPasswordIdContactPage" className="buttonFormEmailClass"
                onChange={(e) => {
                    setSubject(e.target.value)
                    validateSubject(e.target.value);
                }}/>
            {subjectError && <span className="error" id="errorSendEmail">{subjectError}</span>}
            </div>

            <div className="registerFormColumnCard">
            <label className="messageEmail" id="messageEmail">Message</label>

            <textarea rows="5" className="buttonFormEmail"
                onChange={(e) => {
                    setMessage(e.target.value)
                    validateMessage(e.target.value);
                }}></textarea>
            {messageError && <span className="error">{messageError}</span>}
            <button
                        type="button"
                        className="buttonShowPasswordRegister"
                    >
            </button>

            </div>
            
            <button type="button" className="buttonFormSubmitEmail" disabled={usernameError || emailError || subjectError || messageError} onClick={sendMessageToPost}>Send message</button>
        </form>
        </div>
        
        </div>

            <div className={alertState ? 'alertDivRegister3' : 'notDisplayed' }>
  
            <div className="alertDiv-content">
                <i className="checkRegister">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDiv">
                <span className="textDivRegister textDiv-2">An email was sent successfully</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>
            </div>

            <div className={alertStateWrong ? 'alertDiv' : 'notDisplayed' }>
  
            <div className="alertDiv-content">
                <i className="checkWrong">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M6 12L18 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDivWrong">
                <span className="textDiv textDiv-2">An error sending email</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>
            </div>
    </div>
    )
}